module.exports = "././img/fontawesome-webfont.eot";


//////////////////
// WEBPACK FOOTER
// ../~/font-awesome/fonts/fontawesome-webfont.eot
// module id = 831
// module chunks = 0